module.exports = __webpack_public_path__ + "media/images/static/benefit/h2_merit3-fc087df22fa53faf216a43ed54abc8e9.png";